import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectNetworkStartsStreamsStatus, selectDateRange } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { DateRangeWithLabel, Thunk, DetailedStream } from '../types';

export const loadNetworkStartsStreams = (networkId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'networkStartsStreams';

  const { startDate, endDate } = selectDateRange(getState()) as DateRangeWithLabel;

  const endpoint = `${PODCASTERS_SERVICE}/v0/networks/${networkId}/detailedStreams?start=${startDate}&end=${endDate}`;

  /* istanbul ignore next */
  if (selectNetworkStartsStreamsStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_NETWORK_STARTS_STREAMS_REQUEST'));

  try {
    const data: { detailedStreams: DetailedStream[] } = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [key]: data.detailedStreams }), unsetStatus([key])],
        'audience/LOAD_NETWORK_STARTS_STREAMS_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_NETWORK_STARTS_STREAMS_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
